var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8228 5.26899L9.66623 2.14951L10.7061 1.10969C10.9908 0.824974 11.3406 0.682617 11.7555 0.682617C12.1705 0.682617 12.5201 0.824974 12.8043 1.10969L13.8441 2.14951C14.1288 2.43423 14.2774 2.77787 14.2897 3.18043C14.3021 3.58299 14.166 3.92638 13.8812 4.2106L12.8228 5.26899ZM11.7459 6.36452L3.87292 14.2375H0.716309V11.0809L8.58927 3.20791L11.7459 6.36452Z",
    fill: "#3E36B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.9c7aa25d9c06e8200cbf33d7122107b8.svg";
export { ForwardRef as ReactComponent };